/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { Text, View } from '@az/starc-ui';
import { CUSTOMER_REVIEWS_ID } from '../../constants/sectionHash';

const labelMap = {
  customerReviews: 'label_reviews_customerReviews',
};

export const Header = () => {
  const labels = useLabels(labelMap);

  return (
    <View>
      <Text
        variant="display-2"
        weight="medium"
        textCase="uppercase"
        className={styles.heading}
        attributes={{ id: CUSTOMER_REVIEWS_ID }}
      >
        {labels.customerReviews}
      </Text>
      <div className={styles.separator} />
    </View>
  );
};
